module.exports = __webpack_public_path__ + "img/02-live-cover.0968ea1d.png";